import { render, staticRenderFns } from "./CustomText.vue?vue&type=template&id=585632a4&scoped=true&"
import script from "./CustomText.vue?vue&type=script&lang=js&"
export * from "./CustomText.vue?vue&type=script&lang=js&"
import style0 from "./CustomText.vue?vue&type=style&index=0&id=585632a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585632a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585632a4')) {
      api.createRecord('585632a4', component.options)
    } else {
      api.reload('585632a4', component.options)
    }
    module.hot.accept("./CustomText.vue?vue&type=template&id=585632a4&scoped=true&", function () {
      api.rerender('585632a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/campaign/components/CustomText.vue"
export default component.exports